import React, { useMemo } from 'react';
import { UserFund } from 'src/types';
import { compareFunds } from './compareFunds';
import ExpandedFundAgreementTypeHeader from './ExpandedFundAgreementTypeHeader';
import { ExpandedFundClassificationTypeHeader } from './ExpandedFundClassificationTypeHeader';

export interface ExpandedFundGroupHeaderProps {
  fund: UserFund;
  lastFund: UserFund;
}

const ExpandedFundGroupHeader: React.FC<ExpandedFundGroupHeaderProps> = ({
  fund,
  lastFund,
}) => {
  const {
    displayClassification,
    agreementType,
    firstOfClassification,
    firstOfAgreement,
  } = useMemo(() => compareFunds(fund, lastFund), [fund, lastFund]);
  return (
    <React.Fragment>
      {firstOfClassification && (
        <ExpandedFundClassificationTypeHeader>
          {displayClassification}
        </ExpandedFundClassificationTypeHeader>
      )}
      {(firstOfClassification || firstOfAgreement) && (
        <ExpandedFundAgreementTypeHeader
          agreementType={agreementType}
          formattedEntityNames={fund.formattedEntityNames}
          productType={fund.productType}
        />
      )}
    </React.Fragment>
  );
};

export default ExpandedFundGroupHeader;
